// Layout Types

import ProviderLayout from '../layout/ProviderLayout';
import Subscription from '../provider/subscription/Subscription';

// Route Views

const subscriptionRoutes = [
  {
    path: '/subscribe',
    exact: true,
    layout: ProviderLayout,
    component: <Subscription />
  }
];

export default subscriptionRoutes;